import { useDispatch } from "react-redux";

const useWithDispatch = () => {
  const dispatch = useDispatch();

  return (func: Function) => (...args: any) => dispatch(func(...args));
};

export default useWithDispatch;
